export function getEntityName (entityId, entitiesMap) {
  const entity = entitiesMap.get(entityId)
  return entity?.name
}
